import { Component } from '@angular/core';
import type { Params } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { map } from 'rxjs/operators';

import { DetachedRouterOutlet } from '@recruitee/common';

import { ProductOrderEstimateService } from '../../../services/product-order-estimate.service';
import type { ProductOrderParams } from '../product-order.types';
import { ProductOrderParamsIT } from '../product-order.types';

const parseUrlParams = (params: Params): ProductOrderParams => ({
  productId: parseInt(params.productId, 10),
  interval: parseInt(params.interval, 10),
  ...(params.slots && { slots: parseInt(params.slots, 10) }),
  ...(params.quantity && { quantity: parseInt(params.quantity, 10) }),
});

@Component({
  selector: 'rt-product-order-parameterized',
  template: ` <rtc-detached-router-outlet /> `,
  styleUrl: './product-order-parameterized.component.less',
  providers: [
    {
      provide: ProductOrderParamsIT,
      useFactory: (route: ActivatedRoute) =>
        route.params.pipe(map(params => parseUrlParams(params))),
      deps: [ActivatedRoute],
    },
    ProductOrderEstimateService,
  ],
  imports: [DetachedRouterOutlet],
})
export class ProductOrderParameterizedComponent {}
